import Forbidden from '../views/Forbidden';
import NotFound from '../views/NotFound';

const router = [
  {
    name: 'errors.fobidden',
    path: '/403',
    component: Forbidden,
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false,
    },
  },
  {
    name: 'errors.notFound',
    path: '/404',
    component: NotFound,
    meta: {
      requiresAuth: false,
      requiresTeacherRole: false,
    },
  },
  {
    path: '*',
    redirect: '404',
  },
];

export default router;
